import React from "react";
//#region redux
import { useDispatch } from "react-redux";
import { missingDocumentAccepted } from "store/actions/missingDocumentActions";
//#endregion
//#region types
import { StyleEnums } from "models/enums";
import { MissingDocumentFooterProps } from "models/propTypes/missingDocumentPropTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { PageFooter } from "components/common";
import MissingDocumentMoreActions from "./missingDocumentMoreActions";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const MissingDocumentFooter: React.FC<MissingDocumentFooterProps> = (props) => {
  const { missingDocument, reloadHandler, disableSuccessMessages } = props;
  const dispatch = useDispatch();

  const onSubmitSuccess = () => {
    reloadHandler && reloadHandler();
    dispatch(missingDocumentAccepted(missingDocument.id));
  };

  return (
    <PageFooter
      actions={[
        {
          text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Submit2),
          onClick: props.onMissingDocumentAccept,
          type: StyleEnums.DisplayType.Success,
          onActionSuccess: onSubmitSuccess,
        },
      ]}
      moreActions={
        <MissingDocumentMoreActions missingDocument={props.missingDocument} reloadHandler={props.reloadHandler} />
      }
      disableSuccessMessages={disableSuccessMessages}
    />
  );
};

export default MissingDocumentFooter;
